import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { AccountProfileService } from '@shared/services';
import { Constants } from '@shared/models';

@Component({
    'selector': 'app-cancel',
    'templateUrl': './cancel.page.html',
    'styleUrls': ['./cancel.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ]
})
export class CancelPage extends ViewBasePage implements OnInit {
    public vm: any = {};

    constructor(private accountProfileService: AccountProfileService, injector: Injector) {
        super(injector);
    }

    public override ngOnInit(): void {
        this.load();
    }

    private async load() {
        await this.uxHelperService.showSpinner();

        try {
            const data = await this.accountProfileService.get();
            this.vm = data;
            this.vm.phoneNumber = Constants.COMPANY_PHONE_NUMBER;
            this.vm.companyHours = Constants.COMPANY_HOURS;
            await this.uxHelperService.hideSpinner();
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err)
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }
}
